import Lottie from "lottie-react";
import landing from "../images/landing.json";
import arrow from "../images/arrow.png";
import Typewriter from "typewriter-effect";
import overlay from "../images/overlay.png";
import shapeleft from "../images/shapeleft.png";
import shaperight from "../images/shaperight.png";
import Navbar from "./Navbar";

const Landing = () => {
  return (
    <>
      <div style={{ height: "calc(100vh)" }} className="landing relative">
        <Navbar />
        <div className="overflow-hidden flex h-full relative lg:px-32 md:px-20 sm:px-16 px-10">
          <div className="flex items-center justify-start h-full">
            <div className="sm:w-[640px] w-[100%] font-extrabold z-[1]">
              {/* <Typewriter
          className='font-extrabold text-3xl'
            options={{
              strings: ["Grow Your Business Using Our Services"],
              autoStart: true,
              loop: true,
            }}
          /> */}
              <h1 className="lg:text-8xl md:text-7xl sm:text-6xl text-4xl text-white font leading-tight">
                Grow Your Business{" "}
                <span className="text-[#FE4904]">Using Our Services</span>
              </h1>
              <p className="text-gray-300 sm:text-xl text-lg">
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa
                molestiae fugit beatae.
              </p>
              <div className="flex items-center mt-5">
                <button className="bg-gradient-to-r from-[#FE4904] to-[#F7164C] sm:px-10 sm:py-5 px-4 py-2 rounded-xl  hover:from-[#F7164C] hover:to-[#FE4904] text-white transition ease-in-out text-lg">
                  Contact us
                </button>
                {/* <img
              className="ml-4 animate-[arrow_1s_ease-in-out_infinite]"
              src={arrow}
              alt=""
            /> */}
              </div>
            </div>
          </div>
          <img
            src={shapeleft}
            className="sm:max-w-[150px] max-w-[80px] animate-[arrow_3s_ease-in-out_infinite] absolute top-[20%] left-[-20px] overflow-hidden"
            alt=""
          />
          <img
            src={shaperight}
            className="sm:max-w-[150px] max-w-[80px] animate-[arrow_3s_ease-in-out_infinite] absolute top-[50%] right-[-20px] overflow-hidden"
            alt=""
          />
          {/* <div className="">
          <Lottie className="max-w-[650px]" animationData={landing} />
        </div> */}
          <img
            src={overlay}
            className="w-full h-full absolute top-0 left-0 overflow-hidden"
            alt=""
          />
        </div>
      </div>
    </>
  );
};
export default Landing;
